import io from 'socket.io-client';

const getSocketUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:4000';
};

const socket = io(getSocketUrl());

export default socket;

export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:4000');

/* --------------------------------------------------------------- Identity --- */

// Das Token identifiziert diesen Browser gegenueber dem Server -- als Admin
// oder als beanspruchter Spieler. Es liegt im localStorage, damit ein Reload
// mitten im Map-Veto niemanden aus seiner Rolle wirft.
const TOKEN_KEY = 'otter.session';

export const getToken = () => {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null; // z.B. wenn der Browser Storage blockiert
  }
};

const storeToken = (token) => {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    /* ignorieren - dann gilt die Identitaet nur fuer diese Seitenansicht */
  }
};

let identity = null;
const listeners = new Set();

const publish = (next) => {
  identity = next;
  listeners.forEach((fn) => fn(identity));
};

/** Weist sich beim Server aus. Ohne Token bleibt die Verbindung anonym. */
export const authenticate = () => {
  const token = getToken();
  if (!token) {
    publish(null);
    return;
  }

  socket.emit('auth:session', token, (result) => publish(result));
};

export const setToken = (token) => {
  storeToken(token);
  authenticate();
};

export const clearToken = () => {
  storeToken(null);
  publish(null);
};

export const getIdentity = () => identity;

/** Abonniert Identitaetswechsel; liefert sofort den aktuellen Stand nach. */
export const onIdentity = (fn) => {
  listeners.add(fn);
  fn(identity);
  return () => listeners.delete(fn);
};

// Bei jedem (Neu-)Verbinden neu ausweisen: die socket.id wechselt dabei, das
// Token nicht.
socket.on('connect', authenticate);
